import React, { useContext } from 'react';

import { ApiContext } from '_lib/api/apiContext';
import { Location, TimezoneAbbreviationEnum } from '_lib/api/apiTypes.shim';

import { BackdropSpinner } from '_lib/components/BackdropSpinner/BackdropSpinner';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';

import { ManualErrorBoundary } from '_lib/components/ManualErrorBoundary/ManualErrorBoundary';

import { ContentBox } from '_lib/styles/PhoneCall.styled';

import { JobList } from '../JobList/JobList';

export interface CustomerJobHistoryProps {
  companyTimezone: TimezoneAbbreviationEnum;
  companyId: string;
  customerId: string;
  locations?: Location[];
  selectedLocation?: Location;
}

export const CustomerJobHistory = (props: CustomerJobHistoryProps): React.ReactElement => {
  const { companyTimezone, companyId, customerId, locations, selectedLocation } = props;

  const serviceTitanApi = useContext(ApiContext).serviceTitan(companyId);

  const customerJobHistoryQuery = serviceTitanApi.customers.jobHistory(customerId).useListCached();

  if (customerJobHistoryQuery.error) {
    return (
      <ManualErrorBoundary
        errorState={{ message: 'Failed to load Customer Jobs' }}
        onRefresh={async () => {
          await customerJobHistoryQuery.refetch();
        }}
      />
    );
  }

  return (
    <FlexBox sx={{ px: 3, py: 2, flexDirection: 'column' }}>
      {customerJobHistoryQuery.isFetching && (
        <ContentBox>
          <BackdropSpinner open={true} />
        </ContentBox>
      )}
      <JobList
        companyId={companyId}
        customerId={customerId}
        jobHistoryQueryResult={customerJobHistoryQuery}
        locations={locations}
        selectedLocation={selectedLocation}
        companyTimezone={companyTimezone}
      />
    </FlexBox>
  );
};
